import MenuButton from "../MenuButton"
import messageResource from "../../messageResource"
import {NON_BILLABLE_DEFAULT_TYPE_ID} from "../../constants";

const BILLING_TYPE_NOT_SELECTED_VALUE = -1

export default class TypeOfWorkButton extends MenuButton {
    constructor({
        editable = false,
        showCategory = false,
        onTypeOfWorkChangedCb = () => {},
        typeOfWorkMenu = null,
        positionParams = {offset: "0px 1px"},
        onShowMenu = () => {},
        onHideMenu = () => {},
    }) {
        super({
            editable,
            positionParams,
            onShowMenu,
            onHideMenu,
        })

        this.params = {
            showCategory,
            typeOfWorkMenu,
        }

        this.state = {
            typeOfWorkId: BILLING_TYPE_NOT_SELECTED_VALUE,
            typeOfWorkName: '',
            billable: false,
            editable: false,
        }

        this.onAnyStatePropertyChanged(['typeOfWorkId', 'typeOfWorkName', 'billable'], () => this.update())

        this.onStatePropertyChanged('editable', editable => this.setEditable(editable))

        this.onTypeOfWorkChangedCb = onTypeOfWorkChangedCb
    }

    templateHtml() {
        return "<div class='typeOfWorkButton'>" +
               " <div class='value ellipsis'/>" +
               "</div>"
    }

    afterRender() {
        super.afterRender()
        this.$typeLabel = this.find('.value');
        this.update()
    }

    update() {
        this.$el.toggleClass('notSelected', this.state.typeOfWorkId === BILLING_TYPE_NOT_SELECTED_VALUE);
        this.$el.toggleClass('disabled', this.disabled);
        this.$el.toggleClass('editable', this.editable);

        this._updateLabelText()
    }

    _updateLabelText() {
        const text = this._makeLabelText()
        this.$typeLabel.text(text)
        this.$el.attr('title', text)
    }

    _makeLabelText() {
        if (this.state.typeOfWorkId === BILLING_TYPE_NOT_SELECTED_VALUE)
            return messageResource.getMessage('billing_type.not_selected');
        if (this.state.typeOfWorkId === NON_BILLABLE_DEFAULT_TYPE_ID)
            return this.state.typeOfWorkName;

        if (this.params.showCategory) {
            const category = messageResource.getMessage(this.state.billable ? 'billing_type.billable' : 'billing_type.non_billable')
            return `${category}: ${this.state.typeOfWorkName}`
        } else {
            return this.state.typeOfWorkName;
        }
    }

    getMenu() {
        this.params.typeOfWorkMenu.setTypeOfWorkId(this.state.typeOfWorkId)
        return this.params.typeOfWorkMenu
    }

    _change(newId) {
        if (this.state.typeOfWorkId !== newId) {
            this.onTypeOfWorkChangedCb(newId)
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/task/TypeOfWorkButton.js